import { Options } from 'signature_pad';

export enum SignaturePadOutputFile {
  SVG = 'image/svg+xml',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}
export type SignaturePadOutputFileType = keyof typeof SignaturePadOutputFile;

export const SignaturePadConfigDefault: { [index in SignaturePadOutputFileType]?: Options } = {
  JPEG: { backgroundColor: 'rgb(255, 255, 255)' },
};
